import { render, staticRenderFns } from "./RoomSelection.vue?vue&type=template&id=511c483a&scoped=true"
import script from "./RoomSelection.vue?vue&type=script&lang=ts"
export * from "./RoomSelection.vue?vue&type=script&lang=ts"
import style0 from "./RoomSelection.vue?vue&type=style&index=0&id=511c483a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511c483a",
  null
  
)

export default component.exports